const SESSION_CAM_VARIABLES_SET_VALUE = 'raOptimal/sessionCamVariables/setValue/';

export const REQUEST_ID_SET_VALUE = SESSION_CAM_VARIABLES_SET_VALUE + 'requestId';
export const setRequestId = value => ({ type: REQUEST_ID_SET_VALUE, value });
